import React, { useEffect, useRef, useState } from "react";
import "./CertificatePopup.css";
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from "react-share";
import IshraeLogo from "./assets/Ishrae-logo.jpg";
import {
  FacebookIcon,
  LinkedinIcon,
  TwitterIcon,
  WhatsappIcon,
} from "react-share";
export default function CertificatePopup({
  formState = {},
  logo = false,
  message,
  totalEmission,
  onConfirm,
  onClose,
}) {
  const {
    EventName = "Unknown Event",
    EventLocation = "Unknown Location",
    UserName = "Attendee",
  } = formState;
  let headerText, bodyText;
  if (totalEmission < 80) {
    headerText = `Bravo, ${UserName}!`;
    bodyText =
      "The planet's breathing easier — all thanks to your low-carbon efforts.";
  } else if (totalEmission <= 160) {
    headerText = `Nice work, ${UserName}!`;
    bodyText =
      "You're on the right track — keep it going, the planet's noticing.";
  } else {
    headerText = `Loved your effort, ${UserName}!`;
    bodyText =
      "Understanding your footprint is how change begins — and you're leading the way.";
  }
  const [loadingMessage, setLoadingMessage] = useState("Creating...");
  const [isShareCardVisible, setShareCardVisible] = useState(false);
  const [shareURL, setShareURL] = useState(
    "https://ecoindex.octodosolutions.com"
  );
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const generateCertificate = async () => {
    try {
      setIsLoading(true);
      setErrorMessage(null);
      const apiUrl =
        "https://api.ecoindex.ai/api/Individual/GenerateCertificate";
      const requestBody = {
        EventName: formState?.EventName || "Unknown Event",
        TotalAccommodationEmission: formState?.TotalAccommodationEmission,
        TotalTravelEmission: formState?.TotalTravelEmission,
        TotalEmission: totalEmission || 0,
        EventLocation: formState?.EventLocation,
        UserName: formState?.UserName,
        TotalMealEmission: formState?.TotalMealEmission,
        UserEmail: formState?.UserEmail,
      };
      console.log("requestbodyGenerate", requestBody);
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });
      console.log("postm", response);
      if (!response.ok) throw new Error("Failed to generate certificate");

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error generating certificate:", error);
      setErrorMessage("Failed to generate certificate. Please try again.");
      return null;
    } finally {
      setIsLoading(false);
    }
  };
  const handleConfirm = () => {
    if (onConfirm) onConfirm();
    onClose();
  };

  const toggleShareCard = async () => {
    const certificateData = await generateCertificate();
    if (certificateData) {
      const shareableURL = `https://api.ecoindex.ai/api/Individual/share/certificate/${certificateData.certificateId}`;
      setShareURL(shareableURL);
      setShareCardVisible((prev) => !prev);
    }
  };
  const loadingWords = [
    "Creating...",
    "Preparing...",
    "Loading...",
    "Processing...",
    "Finalizing...",
    "Crafting...",
    "Building...",
    "Designing...",
    "Assembling...",
  ];
  useEffect(() => {
    const handleClickOutside = (event) => {
      const shareCard = document.querySelector(".share-card");
      const shareButton = document.querySelector(".emission-share-button");

      if (
        shareCard &&
        !shareCard.contains(event.target) &&
        shareButton &&
        !shareButton.contains(event.target)
      ) {
        setShareCardVisible(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  if (message) {
    return (
      <div className="attendee-modal-overlay">
        <div className="error-modal">
          <p>{message}</p>
          <button onClick={onClose}>Close</button>
        </div>
      </div>
    );
  }
  return (
    <div className="attendee-modal-overlay">
      <div className="certificate-card">
        <div className="logo-cert">
          <div>
            {logo ? (
              <img className="ishrae-logo" src={IshraeLogo} alt="Ishrae Logo" />
            ) : (
              <div></div>
            )}
          </div>
          <div>
            <img
              className="ecoindex-logo"
              src="https://api.ecoindex.ai/Media/ecoindex.png"
              alt="Eco Index Logo"
            />
          </div>
        </div>

        <div className="section-cert">
          <p>
            <strong>Event Name:</strong> {formState?.EventName}
          </p>
          <p>
            📍<strong>Location:</strong> {formState?.EventLocation}
          </p>
        </div>

        <p className="success-message">{headerText}</p>
        <p className="sub-text">{bodyText}</p>

        <div className="emission-box">
          <h4>♻️ Total Emission</h4>
          <div className="emission-value">
            <b>{totalEmission}</b> Kg CO₂e
          </div>
        </div>

        <div className="categories">
          <div className="category">
            <div className="label">🚘 Travel</div>
            <p>
              <b>{formState?.TotalTravelEmission}</b> Kg CO₂e
            </p>
          </div>
          <div className="category">
            <div className="label">🏨 Accommodation</div>
            <p>
              <b>{formState?.TotalAccommodationEmission}</b> Kg CO₂e
            </p>
          </div>
          <div className="category">
            <div className="label">🥗 Food</div>
            <p>
              <b>{formState?.TotalMealEmission}</b> Kg CO₂e
            </p>
          </div>
        </div>
        <div className="attendee-modal-footer">
          <button type="button" className="ok-button" onClick={handleConfirm}>
            OK
          </button>
          <div className="share-container">
            <button
              className="emission-share-button"
              onClick={toggleShareCard}
              disabled={isLoading}
            >
              {isLoading ? (
                <div className="certificate-loading">
                  <div className="spinner"></div>
                  <span>{loadingMessage}</span>
                </div>
              ) : (
                <>
                  <i className="fa fa-share-alt"></i>
                  <span> Share</span>
                </>
              )}
            </button>

            {isShareCardVisible && (
              <div className="share-card">
                <FacebookShareButton
                  url={shareURL}
                  quote="Check out my emissions summary!"
                >
                  <FacebookIcon size={32} round={true} />
                </FacebookShareButton>

                <LinkedinShareButton
                  url={shareURL}
                  title="My Emissions Summary"
                  summary={`Check out this link: ${shareURL}`}
                >
                  <LinkedinIcon size={32} round={true} />
                </LinkedinShareButton>

                <TwitterShareButton url={shareURL} title="My Emissions Summary">
                  <TwitterIcon size={32} round={true} />
                </TwitterShareButton>

                <WhatsappShareButton
                  url={shareURL}
                  title="My Emissions Summary"
                >
                  <WhatsappIcon size={32} round={true} />
                </WhatsappShareButton>
              </div>
            )}
          </div>
        </div>
        {/* <div className="button-cert">
          <button className="ok-button" onClick={onClose}>
            OK
          </button>
          <button className="ok-button" onClick={onClose}>
            Share
          </button>
        </div> */}
      </div>
    </div>
  );
}
